<div class="row">
    <div class="col-12">
        <h3>Form Closed</h3>
        <p>Thank you. You have Closed the form</p>
        <br />
        <p>Please Close this tab to exit</p>
        <p>
            If you should have access to this site, please click
            <a class="btn-link" [routerLink]="['/login']">here</a> to log in
        </p>
    </div>
</div>
